import CarouselComponent from './carousel.component';
import CarouselNavComponent from './carousel-nav.component';
import CarouselSyncComponent from './carousel-sync.component';
import CarouselResource from './carousel-resource.factory';
import CarouselController from './carousel.controller';

export default function Carousel(module) {
    CarouselComponent(module);
    CarouselNavComponent(module);
    CarouselSyncComponent(module);
    CarouselResource(module);
    CarouselController(module);
};